import { render, staticRenderFns } from "./register.vue?vue&type=template&id=c9f44c6e&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=c9f44c6e&prod&lang=css"
import style1 from "./register.vue?vue&type=style&index=1&id=c9f44c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f44c6e",
  null
  
)

export default component.exports